import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    clear: false,
    showToolbar: false,
    showInside: false,
    devices: [],
    units: [],
    showPipe: false,
  },
  getters: {},
  mutations: {
    SetToken(state, data) {
      state.token = data;
    },
    SetClear(state, data) {
      state.clear = data;
    },
    SetToolbar(state, data) {
      state.showToolbar = data;
    },
    SetInside(state, data) {
      state.showInside = data;
    },
    SetDevices(state, data) {
      state.devices = data;
    },
    SetUnits(state, data) {
      state.units = data;
    },
    SetPipe(state, data) {
      state.showPipe = data;
    }
  },
  actions: {},
  modules: {},
});
